export enum ApplyType {
  /**
   * 邀请
   */
  INVITE = 0,
  /**
   * 自主报名
   */
  APPLY = 1
}

export const ApplyTypeTextMap = {
  [ApplyType.APPLY]: '报名',
  [ApplyType.INVITE]: '邀请'
}
